import DimensionInterface from "../../Interfaces/DimensionInterface";
import ShapeInterface from "../../Interfaces/ShapeInterface";
import { useState, useEffect, ChangeEvent, ReactNode } from "react";
import { useFormikContext, ErrorMessage } from "formik";
import { translations } from "../../Helpers/WindowHelpers";
import { updateDimensions, updateIndividualDimension } from '../../Helpers/FormikUpdateFunctions';
import parse from 'html-react-parser';
interface DimensionReactInterface {
    dimension: DimensionInterface,
    selectedShape: ShapeInterface,
    individualDimension?: boolean,
    title: ReactNode,
    disabled?: boolean
}

const Dimension = ({ dimension, selectedShape, individualDimension, title, disabled }: DimensionReactInterface) => {
    const context = useFormikContext<any>();
    const fieldName = `dimension_${dimension.dimension}`;
    const [local, setLocal] = useState<string>(context.values[fieldName]?.value ?? '');
    const [message, setMessage] = useState<string>(context.values[fieldName]?.message ?? '');

    const error = (dimension: string) => context.values[`dimension_${dimension}`]?.message && context.touched[`dimension_${dimension}`] && context.errors[`dimensionsValid`]

    const updateDimension = (value: string) => {
        const parsedValue = value ? parseFloat(value) : 0;
        setLocal(String(parsedValue));
        context.setFieldValue(`${fieldName}.value`, parsedValue);
        console.log('individualDimension', individualDimension);
        if(individualDimension) {
            return updateIndividualDimension({ dimension: dimension.dimension, value: parsedValue }, dimension.ranges, context);
        }
        return updateDimensions([{ dimension: dimension.dimension, value: parsedValue }], selectedShape.shape_id, context);
    }

    useEffect(() => {
        const next = context.values[fieldName]?.value ?? '';
        if (next !== local) {
            setLocal(next);
        }
    }, [context.values[fieldName]?.value]);

    useEffect(() => {
        setMessage(context.values[fieldName]?.message ?? '');
    }, [context.values[fieldName]?.message]);

    return (
        <div className="configurator-content__table--dimension">
            <label htmlFor={fieldName} className="d--flex flex-column">
                {title}

            </label>
            <input name={`${fieldName}.value`}
                id={fieldName}
                type="number"
                inputMode="decimal"
                className={`dimension ${error(dimension.dimension) ? 'error' : ''}`}
                disabled={disabled || !!dimension.formula}
                min={0}
                max={1000}
                step={'any'}
                value={local}
                onChange={(e: ChangeEvent) => updateDimension((e.currentTarget as HTMLInputElement).value)}
                onFocus={(e: ChangeEvent) => (e.currentTarget as HTMLInputElement).select()}
            />
            {translations.unit_of_measurement}
            {message && <DimensionMessage message={message} />}
            <ErrorMessage component={"div"} name={`${fieldName}.disableContinuation`} className={"m-0 configurator-content__error rte links-underline"}></ErrorMessage>
        </div>
    )
}

const DimensionMessage = ({ message }: { message: string }) =>
    message && <div className={`configurator-content__error rte links-blue`}>{parse(message)}</div>


export default Dimension
